import { ADD_MENU_ITEMS } from "../types/admin";
import { getStorage, ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { updateDoc, doc, collection, addDoc, setDoc, getDoc, getDocs, deleteDoc } from "firebase/firestore";
import { db } from "../../config/firebaseConfig";
import { v4 as uuidv4 } from "uuid";
import { capitalizeFLetter, toCamelCase } from "../../functions/conversion";
import { getData } from "./menu";
import { FEEDBACK } from "../types/feedback";
import { HOSTNAME } from "../../config/constants";
import Compressor from "compressorjs";

// const clientRef = doc(db, "www.client.com", "data");

const compressImage = (file, data) => {
  const { quality, maxWidth, maxHeight } = data;
  return new Promise((resolve, reject) => {
    new Compressor(file, {
      quality,
      maxWidth,
      maxHeight,
      strict: true,
      checkOrientation: true,
      convertSize: 25 * 1024,
      mimeType: "image/webp",
      success(result) {
        resolve(result);
      },
      error(err) {
        reject(err);
      },
    });
  });
};

export async function uploadFile(image, dispatch, callback) {
  const storage = getStorage();
  // Image Upload
  const metadata = {
    contentType: "image/*",
    cacheControl: "public,max-age=31536000",
  };

  const fileName = uuidv4();
  const filePath = `${HOSTNAME}/images/` + fileName + ".webp";

  // Upload file and metadata to the object 'images/mountains.jpg'
  const storageRef = ref(storage, filePath);

  let quality = 0.9;
  // const targetSizeKB = 25;

  let compressedFile = await compressImage(image, {
    quality,
    maxWidth: 250,
    maxHeight: 250,
  });

  const uploadTask = uploadBytesResumable(storageRef, compressedFile, metadata);

  // Listen for state changes, errors, and completion of the upload.
  uploadTask.on(
    "state_changed",
    (snapshot) => {
      // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
      const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      console.log("Upload is " + progress + "% done");
      dispatch({
        type: FEEDBACK,
        payload: { loading: true, status: "", message: `Uploading image - ${Math.round(progress)}% done` },
      });
      switch (snapshot.state) {
        case "paused":
          console.log("Upload is paused");
          break;
        case "running":
          console.log("Upload is running");
          break;
        default:
          console.log("");
      }
    },
    (error) => {
      // A full list of error codes is available at
      // https://firebase.google.com/docs/storage/web/handle-errors
      switch (error.code) {
        case "storage/unauthorized":
          // User doesn't have permission to access the object
          console.log("unauthorized");

          dispatch({ type: FEEDBACK, payload: { loading: true, status: "f", message: "Unauthorized" } });
          break;
        case "storage/canceled":
          // User canceled the upload
          dispatch({ type: FEEDBACK, payload: { loading: true, status: "f", message: "Canceled" } });
          console.log("canceled");
          break;
        case "storage/unknown":
          // Unknown error occurred, inspect error.serverResponse
          dispatch({ type: FEEDBACK, payload: { loading: true, status: "f", message: "Unknown storage" } });
          console.log("unknown");
          break;
        default:
          console.log("");
      }
    },
    async () => {
      dispatch({
        type: FEEDBACK,
        payload: { loading: true, status: "", message: "Saving data into database..." },
      });

      // Upload completed successfully, now we can get the download URL
      const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);

      const mediaRef = doc(db, "media", HOSTNAME);
      const imagesRef = doc(mediaRef, "images", fileName);
      await setDoc(imagesRef, {
        ref: filePath,
        url: downloadURL,
      });

      // const parentCollectionRef = collection(db, "media");
      // const nestedCollectionRef = collection(doc(parentCollectionRef, HOSTNAME), "images");

      // const newDocumentRef = doc(nestedCollectionRef, downloadURL); // Automatically generates a unique ID

      // const documentData = {
      //   ref: filePath,
      //   url: downloadURL,
      // };

      // await setDoc(newDocumentRef, documentData);

      callback(downloadURL);
    }
  );
}

export const addMenuItem = (item, clearData, outlet) => async (dispatch, getState) => {
  const { name, price, image, type, filters, sections, bestseller, description, isAlcohol, exciseDuty, vat } = item;

  dispatch({ type: FEEDBACK, payload: { loading: true, status: "", message: "Addiing new menu item..." } });

  try {
    const menuDataRef = doc(db, "menuData", HOSTNAME);
    const outletRef = doc(menuDataRef, "outlet", outlet);
    const getMenuRef = collection(outletRef, "menu");
    const menuId = uuidv4();
    const menuRef = doc(outletRef, "menu", menuId);

    const docSnapshot = await getDocs(getMenuRef);

    let foodExists = false;

    docSnapshot.forEach((doc) => {
      if (doc.data().name === name) {
        foodExists = true;
      }
    });

    if (foodExists) {
      dispatch({
        type: FEEDBACK,
        payload: { loading: true, status: "i", message: `Failed: ${name} already exists in DB` },
      });
      setTimeout(() => {
        dispatch({
          type: FEEDBACK,
          payload: { loading: false, status: "", message: "" },
        });
      }, 2000);
      return;
    }

    if (image) {
      uploadFile(image, dispatch, async (downloadURL) => {
        const newObj = {
          bestseller: bestseller,
          filters: filters,
          id: menuId,
          img: downloadURL,
          name: name,
          price: Number(price),
          ratings: 0,
          type: type,
          sold: 0,
          sections: sections,
          visible: true,
          description: description,
          isAlcohol,
          exciseDuty,
          vat,
        };

        await setDoc(menuRef, newObj);

        const sectionPromises = sections.map(async (section) => {
          const sectionRef = doc(outletRef, "section", section); // Reference to the document "Most Popular" within the "section" collection

          const docSnapshot = await getDoc(sectionRef);

          if (docSnapshot.exists()) {
            const data = docSnapshot.data();
            data.menu.push(menuId);
            await updateDoc(sectionRef, data);
          } else {
            console.log("No such document!");
          }
        });

        await Promise.all(sectionPromises);

        const filterPromises = filters.map(async (filter) => {
          const filterRef = doc(outletRef, "filter", filter); // Reference to the document "Most Popular" within the "filterRef" collection

          const docSnapshot = await getDoc(filterRef);

          if (docSnapshot.exists()) {
            const data = docSnapshot.data();
            data.menu.push(menuId);
            await updateDoc(filterRef, data);
          } else {
            console.log("No such document!");
          }
        });

        await Promise.all(filterPromises);

        dispatch(getData(outlet));

        dispatch({
          type: FEEDBACK,
          payload: { loading: true, status: "s", message: "Added new menu item successfully!" },
        });
        clearData();

        setTimeout(() => {
          dispatch({
            type: FEEDBACK,
            payload: { loading: false, status: "", message: "" },
          });
        }, 2000);
      });
    } else {
      const newObj = {
        bestseller: bestseller,
        filters: filters,
        id: menuId,
        img: "",
        name: name,
        price: Number(price),
        ratings: 0,
        type: type,
        sold: 0,
        sections: sections,
        visible: true,
        description: description,
        isAlcohol,
        exciseDuty,
        vat,
      };

      await setDoc(menuRef, newObj);

      const sectionPromises = sections.map(async (section) => {
        const sectionRef = doc(outletRef, "section", section); // Reference to the document "Most Popular" within the "section" collection

        const docSnapshot = await getDoc(sectionRef);

        if (docSnapshot.exists()) {
          const data = docSnapshot.data();
          data.menu.push(menuId);
          await updateDoc(sectionRef, data);
        } else {
          console.log("No such document!");
        }
      });

      await Promise.all(sectionPromises);

      const filterPromises = filters.map(async (filter) => {
        const filterRef = doc(outletRef, "filter", filter); // Reference to the document "Most Popular" within the "filterRef" collection

        const docSnapshot = await getDoc(filterRef);

        if (docSnapshot.exists()) {
          const data = docSnapshot.data();
          data.menu.push(menuId);
          await updateDoc(filterRef, data);
        } else {
          console.log("No such document!");
        }
      });

      await Promise.all(filterPromises);

      dispatch(getData(outlet));

      dispatch({
        type: FEEDBACK,
        payload: { loading: true, status: "s", message: "Added new menu item successfully!" },
      });
      clearData();

      setTimeout(() => {
        dispatch({
          type: FEEDBACK,
          payload: { loading: false, status: "", message: "" },
        });
      }, 2000);
    }
  } catch (error) {
    console.log(error);
  }
};

function validateEdit(data, editData) {
  const { name, price, imgURL, type, filters, sections, bestseller, description } = data;
  if (!editData) {
    return true;
  }
  if (
    editData.name === name &&
    editData.price === price &&
    editData.img === imgURL &&
    editData.type === type &&
    editData.filters === filters &&
    editData.sections === sections &&
    editData.bestseller === bestseller &&
    editData.description === description
  ) {
    return false;
  } else {
    return true;
  }
}

export const editMenuItem = (item, editData, outlet) => async (dispatch, getState) => {
  const { name, price, image, type, filters, sections, bestseller, description, isAlcohol, exciseDuty, vat } = item;

  const menuDataRef = doc(db, "menuData", HOSTNAME);
  const outletRef = doc(menuDataRef, "outlet", outlet);
  const menuRef = doc(outletRef, "menu", editData.id);

  async function saveToSectionAndFilter() {
    let deleteMenuFromSectionList = [],
      addMenuToSectionList = [],
      deleteMenuFromFilterList = [],
      addMenuToFilterList = [];

    const menuDocSnapshot = await getDoc(menuRef);

    if (menuDocSnapshot.exists()) {
      deleteMenuFromSectionList = menuDocSnapshot.data().sections.filter((section) => !sections.includes(section));
      addMenuToSectionList = sections.filter((section) => !menuDocSnapshot.data().sections.includes(section));
      deleteMenuFromFilterList = menuDocSnapshot.data().filters.filter((filter) => !filters.includes(filter));
      addMenuToFilterList = filters.filter((filter) => !menuDocSnapshot.data().filters.includes(filter));
    }

    const deleteSectionPromises = deleteMenuFromSectionList.map(async (section) => {
      const sectionRef = doc(outletRef, "section", section); // Reference to the document "Most Popular" within the "section" collection

      const docSnapshot = await getDoc(sectionRef);

      if (docSnapshot.exists()) {
        const data = docSnapshot.data();

        const newData = { ...data, menu: data.menu.filter((item) => item !== editData.id) };

        await updateDoc(sectionRef, newData);
      } else {
        console.log("No such document!");
      }
    });

    await Promise.all(deleteSectionPromises);

    const addSectionPromises = addMenuToSectionList.map(async (section) => {
      const sectionRef = doc(outletRef, "section", section); // Reference to the document "Most Popular" within the "section" collection

      const docSnapshot = await getDoc(sectionRef);

      if (docSnapshot.exists()) {
        const data = docSnapshot.data();

        data.menu.push(editData.id);

        await updateDoc(sectionRef, data);
      } else {
        console.log("No such document!");
      }
    });

    await Promise.all(addSectionPromises);

    const deleteFiltersPromises = deleteMenuFromFilterList.map(async (filter) => {
      const filterRef = doc(outletRef, "filter", filter); // Reference to the document "Most Popular" within the "filter" collection

      const docSnapshot = await getDoc(filterRef);

      if (docSnapshot.exists()) {
        const data = docSnapshot.data();

        const newData = { ...data, menu: data.menu.filter((item) => item !== editData.id) };

        await updateDoc(filterRef, newData);
      } else {
        console.log("No such document!");
      }
    });

    await Promise.all(deleteFiltersPromises);

    const addFiltersPromises = addMenuToFilterList.map(async (filter) => {
      const filterRef = doc(outletRef, "filter", filter); // Reference to the document "Most Popular" within the "filter" collection

      const docSnapshot = await getDoc(filterRef);

      if (docSnapshot.exists()) {
        const data = docSnapshot.data();

        data.menu.push(editData.id);

        await updateDoc(filterRef, data);
      } else {
        console.log("No such document!");
      }
    });

    await Promise.all(addFiltersPromises);
  }

  dispatch({
    type: FEEDBACK,
    payload: { loading: true, status: "", message: !editData ? "Addiing new menu item..." : "Updating item..." },
  });

  try {
    if (!validateEdit(item, editData)) {
      dispatch({
        type: FEEDBACK,
        payload: { loading: true, status: "i", message: `Failed: ${name} change the item values in order to update` },
      });
      setTimeout(() => {
        dispatch({
          type: FEEDBACK,
          payload: { loading: false, status: "", message: "" },
        });
      }, 2000);
      return;
    }

    if (typeof image === "string") {
      dispatch({
        type: FEEDBACK,
        payload: { loading: true, status: "", message: "Saving data into database..." },
      });
      // Upload completed successfully, now we can get the download URL

      await saveToSectionAndFilter();

      const newObj = {
        ...editData,
        bestseller: bestseller,
        filters: filters,
        img: image,
        name: name,
        price: Number(price),
        type: type,
        sections: sections,
        visible: true,
        description: description,
        isAlcohol,
        exciseDuty,
        vat,
      };

      await setDoc(menuRef, newObj);

      dispatch(getData(outlet));

      dispatch({
        type: FEEDBACK,
        payload: { loading: true, status: "s", message: "Updated new menu item successfully!" },
      });
      setTimeout(() => {
        dispatch({
          type: FEEDBACK,
          payload: { loading: false, status: "", message: "" },
        });
      }, 2000);

      return;
    }

    uploadFile(image, dispatch, async (downloadURL) => {
      await saveToSectionAndFilter();

      const newObj = {
        ...editData,
        bestseller: bestseller,
        filters: filters,
        img: downloadURL,
        name: name,
        price: Number(price),
        type: type,
        sections: sections,
        description: description,
        isAlcohol,
        exciseDuty,
        vat,
      };

      await setDoc(menuRef, newObj);

      dispatch(getData(outlet));

      dispatch({
        type: FEEDBACK,
        payload: { loading: true, status: "s", message: "Updated menu item successfully!" },
      });
      setTimeout(() => {
        dispatch({
          type: FEEDBACK,
          payload: { loading: false, status: "", message: "" },
        });
      }, 2000);
    });
  } catch (error) {
    console.log(error);
  }
};

export const editMenuVisibility = (data, visibility, outlet) => async (dispatch) => {
  dispatch({
    type: FEEDBACK,
    payload: { loading: true, status: "", message: "Updating item..." },
  });

  const menuDataRef = doc(db, "menuData", HOSTNAME);
  const outletRef = doc(menuDataRef, "outlet", outlet);

  const isVisible = visibility === "enable" ? true : false;
  const menuRef = doc(outletRef, "menu", data.id);

  const newObj = {
    ...data,
    visible: isVisible,
  };

  await setDoc(menuRef, newObj);

  dispatch(getData(outlet));
  dispatch({
    type: FEEDBACK,
    payload: { loading: true, status: "s", message: `${capitalizeFLetter(visibility)}d menu item successfully!` },
  });
  setTimeout(() => {
    dispatch({
      type: FEEDBACK,
      payload: { loading: false, status: "", message: "" },
    });
  }, 2000);
};

export const deleteMenuItem = (data, outlet) => async (dispatch) => {
  dispatch({
    type: FEEDBACK,
    payload: { loading: true, status: "", message: "Deleting item..." },
  });

  const menuDataRef = doc(db, "menuData", HOSTNAME);
  const outletRef = doc(menuDataRef, "outlet", outlet);

  const deleteSectionPromises = data.sections.map(async (section) => {
    const sectionRef = doc(outletRef, "section", section); // Reference to the document "Most Popular" within the "section" collection

    const docSnapshot = await getDoc(sectionRef);

    if (docSnapshot.exists()) {
      const sectionData = docSnapshot.data();

      const newData = { ...sectionData, menu: sectionData.menu.filter((item) => item !== data.id) };

      await updateDoc(sectionRef, newData);
    } else {
      console.log("No such document!");
    }
  });

  await Promise.all(deleteSectionPromises);

  const deleteFilterPromises = data.filters.map(async (filter) => {
    const filterRef = doc(outletRef, "filter", filter); // Reference to the document "Most Popular" within the "filter" collection

    const docSnapshot = await getDoc(filterRef);

    if (docSnapshot.exists()) {
      const filterData = docSnapshot.data();

      const newData = { ...filterData, menu: filterData.menu.filter((item) => item !== data.id) };

      await updateDoc(filterRef, newData);
    } else {
      console.log("No such document!");
    }
  });

  await Promise.all(deleteFilterPromises);

  const menuRef = doc(outletRef, "menu", data.id);

  await deleteDoc(menuRef);

  dispatch(getData(outlet));
  dispatch({
    type: FEEDBACK,
    payload: { loading: true, status: "s", message: `Deleted menu item successfully!` },
  });
  setTimeout(() => {
    dispatch({
      type: FEEDBACK,
      payload: { loading: false, status: "", message: "" },
    });
  }, 2000);
};

export const addfilterItem = (item, clearInput, outlet) => async (dispatch, getState) => {
  const { name, image } = item;

  dispatch({ type: FEEDBACK, payload: { loading: true, status: "", message: "Addiing new filter..." } });

  try {
    const menuDataRef = doc(db, "menuData", HOSTNAME);
    const outletRef = doc(menuDataRef, "outlet", outlet);
    const getFilterRef = collection(outletRef, "filter");

    const docSnapshot = await getDocs(getFilterRef);

    let filterExists = false;

    docSnapshot.forEach((doc) => {
      if (doc.data().name === name) {
        filterExists = true;
      }
    });

    if (filterExists) {
      dispatch({
        type: FEEDBACK,
        payload: { loading: true, status: "i", message: `Failed: ${name} already exists in DB` },
      });
      setTimeout(() => {
        dispatch({
          type: FEEDBACK,
          payload: { loading: false, status: "", message: "" },
        });
      }, 2000);
      return;
    }

    const filterId = uuidv4();
    const filterRef = doc(outletRef, "filter", filterId);

    uploadFile(image, dispatch, async (downloadURL) => {
      const { filterData } = getState().menu;

      await setDoc(filterRef, {
        id: filterId,
        img: downloadURL,
        isSelected: false,
        name: name,
        ref: name,
        order: filterData.length + 1,
        menu: [],
        visible: true,
      });
      dispatch(getData(outlet));
      clearInput();

      dispatch({
        type: FEEDBACK,
        payload: { loading: true, status: "s", message: "Added new filter successfully!" },
      });

      setTimeout(() => {
        dispatch({
          type: FEEDBACK,
          payload: { loading: false, status: "", message: "" },
        });
      }, 2000);
    });
  } catch (error) {
    console.log(error);
  }
};

export const addsectionItem = (data, clearInput, outlet) => async (dispatch, getState) => {
  const { name, image } = data;

  dispatch({ type: FEEDBACK, payload: { loading: true, status: "", message: "Addiing new section..." } });

  try {
    const menuDataRef = doc(db, "menuData", HOSTNAME);
    const outletRef = doc(menuDataRef, "outlet", outlet);
    const getSectionRef = collection(outletRef, "section");

    const docSnapshot = await getDocs(getSectionRef);

    let sectionExists = false;

    docSnapshot.forEach((doc) => {
      if (doc.data().name === name) {
        sectionExists = true;
      }
    });

    if (sectionExists) {
      dispatch({
        type: FEEDBACK,
        payload: { loading: true, status: "i", message: `Failed: ${name} already exists in DB` },
      });

      setTimeout(() => {
        dispatch({
          type: FEEDBACK,
          payload: { loading: false, status: "", message: "" },
        });
      }, 2000);
      return;
    }
    const sectionId = uuidv4();
    const sectionRef = doc(outletRef, "section", sectionId);

    uploadFile(image, dispatch, async (downloadURL) => {
      const { sectionData } = getState().menu;

      await setDoc(sectionRef, {
        id: sectionId,
        img: downloadURL,
        name: name,
        order: sectionData.length + 1,
        menu: [],
        visible: true,
      });

      clearInput();
      dispatch(getData(outlet));

      dispatch({
        type: FEEDBACK,
        payload: { loading: true, status: "s", message: "Added new section successfully!" },
      });

      setTimeout(() => {
        dispatch({
          type: FEEDBACK,
          payload: { loading: false, status: "", message: "" },
        });
      }, 2000);
    });
  } catch (error) {
    console.log(error);
  }
};

function validateFilterSectionEdit(data, editData) {
  const { name, image } = data;
  if (!editData) {
    return true;
  }
  if (editData.name === name && editData.img === image) {
    return false;
  } else {
    return true;
  }
}

export const editfilterItem = (item, editData, outlet) => async (dispatch) => {
  const { name, image } = item;

  dispatch({ type: FEEDBACK, payload: { loading: true, status: "", message: "Updating new filter..." } });

  try {
    if (!validateFilterSectionEdit(item, editData)) {
      dispatch({
        type: FEEDBACK,
        payload: {
          loading: true,
          status: "i",
          message: `Failed: ${name} change the item values in order to update`,
        },
      });
      setTimeout(() => {
        dispatch({
          type: FEEDBACK,
          payload: { loading: false, status: "", message: "" },
        });
      }, 2000);
      return;
    }

    const menuDataRef = doc(db, "menuData", HOSTNAME);
    const outletRef = doc(menuDataRef, "outlet", outlet);
    const filterRef = doc(outletRef, "filter", editData.id);
    const getFilterRef = collection(outletRef, "filter");

    const docSnapshot = await getDocs(getFilterRef);

    let filterExists = false;

    docSnapshot.forEach((doc) => {
      const docData = doc.data();
      if (docData.name === name && docData.id !== editData.id) {
        filterExists = true;
      }
    });

    if (filterExists) {
      dispatch({
        type: FEEDBACK,
        payload: { loading: true, status: "i", message: `Failed: ${name} already exists in DB` },
      });
      setTimeout(() => {
        dispatch({
          type: FEEDBACK,
          payload: { loading: false, status: "", message: "" },
        });
      }, 2000);
      return;
    }

    if (typeof image === "string") {
      dispatch({
        type: FEEDBACK,
        payload: { loading: true, status: "", message: "Saving data into database..." },
      });
      // Upload completed successfully, now we can get the download URL

      const newObj = {
        ...editData,
        name: name,
      };

      await setDoc(filterRef, newObj);

      dispatch(getData(outlet));

      dispatch({
        type: FEEDBACK,
        payload: { loading: true, status: "s", message: "Updated new menu item successfully!" },
      });
      setTimeout(() => {
        dispatch({
          type: FEEDBACK,
          payload: { loading: false, status: "", message: "" },
        });
      }, 2000);

      return;
    }

    uploadFile(image, dispatch, async (downloadURL) => {
      await setDoc(filterRef, {
        ...editData,
        name: name,
        img: downloadURL,
      });
      dispatch(getData(outlet));

      dispatch({
        type: FEEDBACK,
        payload: { loading: true, status: "s", message: "Updated new filter successfully!" },
      });

      setTimeout(() => {
        dispatch({
          type: FEEDBACK,
          payload: { loading: false, status: "", message: "" },
        });
      }, 2000);
    });
  } catch (error) {
    console.log(error);
  }
};

export const editsectionItem = (data, editData, outlet) => async (dispatch, getState) => {
  const { name, image } = data;
  dispatch({ type: FEEDBACK, payload: { loading: true, status: "", message: "Updating new section..." } });

  try {
    if (!validateFilterSectionEdit(data, editData)) {
      dispatch({
        type: FEEDBACK,
        payload: {
          loading: true,
          status: "i",
          message: `Failed: ${name} change the item values in order to update`,
        },
      });
      setTimeout(() => {
        dispatch({
          type: FEEDBACK,
          payload: { loading: false, status: "", message: "" },
        });
      }, 2000);
      return;
    }
    const menuDataRef = doc(db, "menuData", HOSTNAME);
    const outletRef = doc(menuDataRef, "outlet", outlet);
    const sectionRef = doc(outletRef, "section", editData.id);
    const getSectionRef = collection(outletRef, "section");

    const docSnapshot = await getDocs(getSectionRef);

    let sectionExists = false;

    docSnapshot.forEach((doc) => {
      const docData = doc.data();
      if (docData.name === name && docData.id !== editData.id) {
        sectionExists = true;
      }
    });

    if (sectionExists) {
      dispatch({
        type: FEEDBACK,
        payload: { loading: true, status: "i", message: `Failed: ${name} already exists in DB` },
      });

      setTimeout(() => {
        dispatch({
          type: FEEDBACK,
          payload: { loading: false, status: "", message: "" },
        });
      }, 2000);
      return;
    }

    if (typeof image === "string") {
      dispatch({
        type: FEEDBACK,
        payload: { loading: true, status: "", message: "Saving data into database..." },
      });
      // Upload completed successfully, now we can get the download URL

      await setDoc(sectionRef, {
        ...editData,
        name: name,
      });

      dispatch(getData(outlet));

      dispatch({
        type: FEEDBACK,
        payload: { loading: true, status: "s", message: "Updated new section successfully!" },
      });

      setTimeout(() => {
        dispatch({
          type: FEEDBACK,
          payload: { loading: false, status: "", message: "" },
        });
      }, 2000);

      return;
    }

    uploadFile(image, dispatch, async (downloadURL) => {
      await setDoc(sectionRef, {
        ...editData,
        name: name,
        img: downloadURL,
      });

      dispatch(getData(outlet));

      dispatch({
        type: FEEDBACK,
        payload: { loading: true, status: "s", message: "Updated new filter successfully!" },
      });

      setTimeout(() => {
        dispatch({
          type: FEEDBACK,
          payload: { loading: false, status: "", message: "" },
        });
      }, 2000);
    });
  } catch (error) {
    console.log(error);
  }
};

export const editFilterVisibility = (data, visibility, outlet) => async (dispatch) => {
  dispatch({
    type: FEEDBACK,
    payload: { loading: true, status: "", message: "Updating item..." },
  });

  const menuDataRef = doc(db, "menuData", HOSTNAME);
  const outletRef = doc(menuDataRef, "outlet", outlet);

  const isVisible = visibility === "enable" ? true : false;
  const filterRef = doc(outletRef, "filter", data.id);

  const newObj = {
    ...data,
    visible: isVisible,
  };

  await setDoc(filterRef, newObj);

  dispatch(getData(outlet));
  dispatch({
    type: FEEDBACK,
    payload: { loading: true, status: "s", message: `${capitalizeFLetter(visibility)}d filter successfully!` },
  });
  setTimeout(() => {
    dispatch({
      type: FEEDBACK,
      payload: { loading: false, status: "", message: "" },
    });
  }, 2000);
};

export const deleteFilterItem = (data, outlet) => async (dispatch) => {
  dispatch({
    type: FEEDBACK,
    payload: { loading: true, status: "", message: "Deleting item..." },
  });
  const menuDataRef = doc(db, "menuData", HOSTNAME);
  const outletRef = doc(menuDataRef, "outlet", outlet);

  const deleteFilterFromMenuPromises = data.menu.map(async (menu) => {
    const menuRef = doc(outletRef, "menu", menu); // Reference to the document "Most Popular" within the "section" collection

    const docSnapshot = await getDoc(menuRef);

    if (docSnapshot.exists()) {
      const menuData = docSnapshot.data();
      const newData = { ...menuData, filters: menuData.filters.filter((item) => item !== data.id) };

      await updateDoc(menuRef, newData);
    } else {
      console.log("No such document!");
    }
  });

  await Promise.all(deleteFilterFromMenuPromises);

  const filterRef = doc(outletRef, "filter", data.id);

  await deleteDoc(filterRef);

  dispatch(getData(outlet));
  dispatch({
    type: FEEDBACK,
    payload: { loading: true, status: "s", message: `Deleted filter item successfully!` },
  });
  setTimeout(() => {
    dispatch({
      type: FEEDBACK,
      payload: { loading: false, status: "", message: "" },
    });
  }, 2000);
};

export const editSectionVisibility = (data, visibility, outlet) => async (dispatch) => {
  dispatch({
    type: FEEDBACK,
    payload: { loading: true, status: "", message: "Updating item..." },
  });

  const menuDataRef = doc(db, "menuData", HOSTNAME);
  const outletRef = doc(menuDataRef, "outlet", outlet);

  const isVisible = visibility === "enable" ? true : false;
  const sectionRef = doc(outletRef, "section", data.id);

  const newObj = {
    ...data,
    visible: isVisible,
  };

  await setDoc(sectionRef, newObj);

  dispatch(getData(outlet));
  dispatch({
    type: FEEDBACK,
    payload: { loading: true, status: "s", message: `${capitalizeFLetter(visibility)}d section successfully!` },
  });
  setTimeout(() => {
    dispatch({
      type: FEEDBACK,
      payload: { loading: false, status: "", message: "" },
    });
  }, 2000);
};

export const deleteSectionItem = (data, outlet) => async (dispatch) => {
  dispatch({
    type: FEEDBACK,
    payload: { loading: true, status: "", message: "Deleting item..." },
  });

  const menuDataRef = doc(db, "menuData", HOSTNAME);
  const outletRef = doc(menuDataRef, "outlet", outlet);

  const deleteSectionFromMenuPromises = data.menu.map(async (menu) => {
    const menuRef = doc(outletRef, "menu", menu); // Reference to the document "Most Popular" within the "section" collection

    const docSnapshot = await getDoc(menuRef);

    if (docSnapshot.exists()) {
      const menuData = docSnapshot.data();
      const newData = { ...menuData, sections: menuData.sections.filter((item) => item !== data.id) };

      await updateDoc(menuRef, newData);
    } else {
      console.log("No such document!");
    }
  });

  await Promise.all(deleteSectionFromMenuPromises);

  const sectionRef = doc(outletRef, "section", data.id);

  await deleteDoc(sectionRef);

  dispatch(getData(outlet));
  dispatch({
    type: FEEDBACK,
    payload: { loading: true, status: "s", message: `Deleted section item successfully!` },
  });
  setTimeout(() => {
    dispatch({
      type: FEEDBACK,
      payload: { loading: false, status: "", message: "" },
    });
  }, 2000);
};

export const arrangeFilterTable = (table, outlet) => async (dispatch) => {
  dispatch({
    type: FEEDBACK,
    payload: { loading: true, status: "", message: "Re-arranging items..." },
  });

  const menuDataRef = doc(db, "menuData", HOSTNAME);
  const outletRef = doc(menuDataRef, "outlet", outlet);
  const filterTable = table.map(async (data, index) => {
    const docRef = doc(outletRef, "filter", data.id);
    await updateDoc(docRef, { ...data, order: index + 1 });
  });

  await Promise.all(filterTable);

  dispatch(getData(outlet));
  dispatch({
    type: FEEDBACK,
    payload: { loading: true, status: "s", message: `Re-arranged filter item successfully!` },
  });
  setTimeout(() => {
    dispatch({
      type: FEEDBACK,
      payload: { loading: false, status: "", message: "" },
    });
  }, 2000);
};

export const arrangeSectionTable = (table, outlet) => async (dispatch) => {
  dispatch({
    type: FEEDBACK,
    payload: { loading: true, status: "", message: "Re-arranging items..." },
  });

  const menuDataRef = doc(db, "menuData", HOSTNAME);
  const outletRef = doc(menuDataRef, "outlet", outlet);

  const sectionTable = table.map(async (data, index) => {
    const docRef = doc(outletRef, "section", data.id);
    await updateDoc(docRef, { ...data, order: index + 1 });
  });

  await Promise.all(sectionTable);

  dispatch(getData(outlet));
  dispatch({
    type: FEEDBACK,
    payload: { loading: true, status: "s", message: `Re-arranged filter item successfully!` },
  });
  setTimeout(() => {
    dispatch({
      type: FEEDBACK,
      payload: { loading: false, status: "", message: "" },
    });
  }, 2000);
};

export const arrangeMenuInsideSectionTable = (section, table, outlet) => async (dispatch) => {
  dispatch({
    type: FEEDBACK,
    payload: { loading: true, status: "", message: "Re-arranging items..." },
  });

  const menuDataRef = doc(db, "menuData", HOSTNAME);
  const outletRef = doc(menuDataRef, "outlet", outlet);

  const docRef = doc(outletRef, "section", section.id);

  const docSnapshot = await getDoc(docRef);

  if (docSnapshot.exists()) {
    const data = docSnapshot.data();
    const newMenuList = table.map((item) => item.id);
    await updateDoc(docRef, { ...data, menu: newMenuList });
  } else {
    console.log("No such document!");
  }

  dispatch(getData(outlet));
  dispatch({
    type: FEEDBACK,
    payload: { loading: true, status: "s", message: `Re-arranged filter item successfully!` },
  });
  setTimeout(() => {
    dispatch({
      type: FEEDBACK,
      payload: { loading: false, status: "", message: "" },
    });
  }, 2000);
};
